
    <mat-card>

        <mat-card-header>
            <mat-card-title>Your Recent Projects</mat-card-title>
            <mat-card-subtitle>Quick access to cables for your recent projects</mat-card-subtitle>

        </mat-card-header>


        <mat-card-content>
            <div>

                @if (vm.showRecentProjects) {

                @for (project of vm.recentProjects; track project) {
                <button mat-button (click)="onClick(project.uid)" color="accent">
                    <div class="text-left">{{project.projectNumber}}: {{project.projectName}}</div><mat-icon>group_work</mat-icon>
                </button>
                }

                }

                @if (!vm.showRecentProjects) {
                <p>You have no recent projects</p>
                }

            </div>


        </mat-card-content>

        <mat-card-actions>
            <a mat-button routerLink="/projects" color="primary">
                <mat-icon>work_outline</mat-icon>
                View, Create and Edit Your Projects
            </a>
        </mat-card-actions>
    </mat-card>
